import React from 'react';
import { Dropdown } from 'antd';
import RoundedButton from '../../../../components/RoundedButton/RoundedButton';
import cn from 'classnames';
import styles from './DescriptionDropdown.module.scss';

const DescriptionDropdown = ({
  className,
  buttonProps,
  description,
  dropdownProps,
}) => {
  return (
    <div className={cn(styles.root, className)}>
      <p className={styles.description}>{description}</p>
      <Dropdown trigger={['click']} {...dropdownProps}>
        <RoundedButton type="secondary" invert {...buttonProps} />
      </Dropdown>
    </div>
  );
};

export default DescriptionDropdown;
